// Schema: TimeSheet (verified live in Blocks OS).
export const INSERT_TIME_SHEET_MUTATION = `
  mutation InsertTimeSheet($input: TimeSheetInsertInput!) {
    insertTimeSheet(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_TIME_SHEET_MUTATION = `
  mutation UpdateTimeSheet($filter: String!, $input: TimeSheetUpdateInput!) {
    updateTimeSheet(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_TIME_SHEET_MUTATION = `
  mutation DeleteTimeSheet($filter: String!, $input: TimeSheetDeleteInput!) {
    deleteTimeSheet(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;
